"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepare2UpdateBasket = void 0;
var _reduxActions = require("redux-actions");
var PREFIX = 'EDIT_FORM';
var prepare2UpdateBasket = exports.prepare2UpdateBasket = (0, _reduxActions.createAction)("".concat(PREFIX, "/prepare2UpdateBasket"), function (basketID, values) {
  return {
    basketID: basketID,
    values: values
  };
});